import { useTranslation } from "react-i18next"
import { cn } from "@nexus/ui"

import {
  PERSONA_NEW_STATUS_DOT_CLASS,
  PERSONA_STATUS_BADGE_BASE,
  personaStatusBadgeClassName,
  personaStatusIsAwaitingReview,
  personaStatusLabel,
} from "../../lib/persona-status"
import type { PersonaStatus } from "../../types/personas.types"

export function PersonaStatusBadge({
  status,
  className,
}: {
  status: PersonaStatus
  className?: string
}) {
  const { t } = useTranslation()
  const label = personaStatusLabel(t, status)
  const isAwaitingReview = personaStatusIsAwaitingReview(status)

  return (
    <span className={cn(PERSONA_STATUS_BADGE_BASE, personaStatusBadgeClassName(status), className)}>
      {isAwaitingReview ? (
        <>
          <span aria-hidden className={PERSONA_NEW_STATUS_DOT_CLASS} />
          {/* `aria-label` on a role-less span is dropped by some screen readers, which would
              leave the chip silent. Duplicated sr-only copy always announces. */}
          <span aria-hidden>{label}</span>
          <span className="sr-only">
            {t("personas.status.newAria", "New — awaiting your review")}
          </span>
        </>
      ) : (
        label
      )}
    </span>
  )
}
